import React from 'react';
import _ from 'lodash';
import DeleteIcon from '@mui/icons-material/Delete';
import NoteIcon from '@mui/icons-material/Create';
import { __ } from './__';

/**
 * Vratime buttony pre klienta.
 *
 * @param {Object} item
 * @param {Object} options
 *
 * @return {Object}
 */
export const getClientButtons = (item, options = {}) => {
    options = { ...{
        hasPermissionView: false,
        hasPermissionComment: false,
        hasPermissionDelete: false,
    }, ...options };

    let buttons = {
        note: {
            name: __('Zmeniť internú poznámku'),
            icon: <NoteIcon />,
            callback: () => {},
            options: {},
        },
        delete: {
            name: __('Zmazať'),
            icon: <DeleteIcon />,
            callback: () => {},
            options: {},
        },
    };

    if (!options.hasPermissionComment) {
        // Nema pravo
        buttons = _.omit(buttons, ['note']);
    }

    if (!options.hasPermissionDelete) {
        // Nema pravo
        buttons = _.omit(buttons, ['delete']);
    }

    return buttons;
};
